<template>
    <div v-bind:class="{ 'loading loading-machines': !init || loading}">
        <div v-if="init">
            <div class="section-search-result">
                <div class="container">
                    <div class="description">
                        <h1 class="h3">{{ texts.searchResult }}</h1>
                        <p>{{ texts.foundMachines }}</p>
                    </div>
                    <form v-on:submit.prevent="newSearch">
                        <input type="text" name="search" class="text-field whisperer" v-model="s" :disabled="loading" />
                        <button type="submit" class="btn btn-black btn-lg" :disabled="loading">{{ texts.search }}</button>
                    </form>
                </div>
            </div>
            <div class="section-machines" v-show="total > 0">
                <div class="container">
                    <div class="machines" v-bind:class="{ 'loading': !init || loading}">
                        <machine v-for="m in machines" :key="m.url" :texts="texts" :machine="m"></machine>
                    </div>
                    <div class="buttons" v-show="isLoadMoreVisible">
                        <a v-on:click.prevent="clickLoadMore" class="btn btn-black btn-lg" :disabled="loading">{{ texts.next_Count }}</a>
                    </div>
                </div>
            </div>
            <div class="section-btn-box section-no-machines" v-show="total == 0">
                <div class="container">
                    <h2 class="h1">
                        {{ texts.noMachines_Search }}
                    </h2>
                    <p class="description">
                        {{ texts.noMachines_Description }}
                    </p>
                    <p class="buttons">
                        <a class="btn btn-primary btn-lg" v-bind:href="urls.haveNotFound">{{ texts.notFindMachine }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var axios = require('axios');
    import Machine from './_machine.vue'
    var url = require('url');

    export default {
        name: 'app',
        components: {
            Machine
        },
        data() {
            return {
                loading: false,
                init: false,
                machines: [],
                s: __SEARCH__,
                total: 0,
                language: __L__,
                page: 1,
                pageSize: 18,
                texts: [],
                urls: []
            }
        },
        computed: {
            isLoadMoreVisible() {
                var self = this
                if (self.pageSize * self.page < self.total) {
                    return true
                }

                return false
            }
        },
        created() {
            var self = this;
            self.fetch(true);
        },
        methods: {
            newSearch() {
                var self = this;

                self.fetch(true);

                if (window.history.replaceState) {                    
                    var u = url.parse(window.location.href);
                    var query = { s: self.s };                                       
                        
                    var nu = url.format({
                        pathname: u.pathname,
                        query: query
                    });

                    window.history.replaceState('', document.title, nu);
                }
            },
            clickLoadMore() {
                var self = this;
                self.fetch(false);
            },
            fetch(reset) {
                reset = reset || false;
                var self = this;

                if (self.loading) return;

                self.loading = true;

                if (reset) {
                    self.page = 0;
                }

                axios.get('/api/machines', {
                    params: {
                        language: self.language,
                        page: self.page + 1,
                        oneMachineBrand: false,
                        s: self.s
                    }
                }).then(response => {
                    var newMachines = response.data.machines;

                    if (reset) {
                        self.machines = [];
                    }

                    for (var i = 0; i < newMachines.length; i++) {
                        var machine = newMachines[i];
                        self.machines.push(machine);
                    }

                    self.texts = response.data.texts;
                    self.urls = response.data.urls;
                    self.total = response.data.total;
                    self.page++;
                    self.loading = false;
                    self.init = true;
                })
                    .catch(error => {
                        self.init = true;
                        self.loading = false;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// global-search.vue?0b9de196